module.exports = __webpack_public_path__ + "static/media/NTU_College_of_Engineering.55e98125.jpg";